import { Controller } from 'stimulus';

export default class extends Controller {
  static values = {
    composerId: String,
    prompt: String,
  };

  copyToComposer(event) {
    const promptText = event.currentTarget.dataset.aiPromptChipsPromptValue;
    const composerElement = document.getElementById(this.composerIdValue);

    if (!composerElement) {
      console.warn(
        `Composer element with ID "${this.composerIdValue}" not found`
      );
      return;
    }

    const textarea = composerElement.querySelector('textarea');
    if (textarea) {
      textarea.value = promptText;
      textarea.focus();
      // Trigger input event so other controllers know the value changed
      textarea.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
}
